import { helper as buildHelper } from '@ember/component/helper';

export function formatMilliseconds(params) 
{
	let totalMillis = params[0];
	let precision = params[1];
	if(totalMillis == null)
		return "";
	
	let hours = Math.floor(totalMillis/(1000*60*60));
	totalMillis = totalMillis-(hours*60*60*1000);
	let minutes = Math.floor(totalMillis/(1000*60));
	totalMillis = totalMillis-(minutes*60*1000);
	let seconds = Math.floor(totalMillis/(1000));
	totalMillis = totalMillis-(seconds*1000);
	
	let hoursFormatted = "";
	if(hours > 0)
		hoursFormatted = hours.toLocaleString(undefined, {minimumIntegerDigits: 1})+":";
	let minutesFormatted = ""
	if(minutes>=0)
		minutesFormatted = minutes.toLocaleString(undefined, {minimumIntegerDigits: 2})+":";
	
	if(precision == 1000)
	{
		return hoursFormatted+minutesFormatted+seconds.toLocaleString(undefined, {minimumIntegerDigits: 2});
	}
	else if(precision == 100)
	{
		totalMillis=parseInt(totalMillis/100);
		totalMillis = totalMillis.toLocaleString(undefined, {minimumIntegerDigits: 1});
	}
	else if(precision == 10)
	{
		totalMillis=parseInt(totalMillis/10);
		totalMillis = totalMillis.toLocaleString(undefined, {minimumIntegerDigits: 2});
	}
	else if(precision == 1)
	{
		totalMillis=parseInt(totalMillis/10);
		totalMillis = totalMillis.toLocaleString(undefined, {minimumIntegerDigits: 3});
	}
	
	return 	hoursFormatted+minutesFormatted+seconds.toLocaleString(undefined, {minimumIntegerDigits: 2})+
			"."+totalMillis;
}

export default buildHelper(formatMilliseconds);